<template>
  <div class="atlas-get-started-widget">
    <div class="atlas-get-started-widget__left">
      <h1 class="atlas-get-started-widget__headline">
        <span class="atlas-get-started-widget__headline-line atlas-get-started-widget__headline-line--nowrap">Turn your photos into</span>
        <span class="atlas-get-started-widget__headline-line">effortless social posts</span>
      </h1>
      <ul class="atlas-get-started-widget__features">
        <li class="atlas-get-started-widget__feature">
          <span class="atlas-get-started-widget__feature-icon">
            <IconEmbedded name="calendar_2" :size="20" color="#3f6967" />
          </span>
          <span class="atlas-get-started-widget__feature-text"> Create a steady stream of posts in minutes </span>
        </li>
        <li class="atlas-get-started-widget__feature">
          <span class="atlas-get-started-widget__feature-icon">
            <IconEmbedded name="users_2" :size="20" color="#3f6967" />
          </span>
          <span class="atlas-get-started-widget__feature-text"> Engage travelers with authentic content </span>
        </li>
        <li class="atlas-get-started-widget__feature">
          <span class="atlas-get-started-widget__feature-icon">
            <IconEmbedded name="ascending_2" :size="20" color="#3f6967" />
          </span>
          <span class="atlas-get-started-widget__feature-text"> Save time and keep your channels active </span>
        </li>
      </ul>
      <SrpButton
        tag="RouterLink"
        size="normal"
        fill="solid"
        color="teal"
        :isDisabled="props.isCustomerDisabled"
        :to="{ name: 'CalendarPosts', params: { customerId: props.customerId } }"
        class="atlas-get-started-widget__cta"
      >
        <template #icon><IconEmbedded name="ai_2" :size="20" color="#fff" /></template>
        Get Started
      </SrpButton>
    </div>
    <div class="atlas-get-started-widget__right">
      <AtlasGettingStartedVisual />
    </div>
  </div>
</template>

<script setup lang="ts">
import SrpButton from "@components/ui/SrpButton.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import AtlasGettingStartedVisual from "@views/Community/ContentCalendar/AtlasGettingStartedVisual.vue";

const props = withDefaults(
  defineProps<{
    customerId: string;
    isCustomerDisabled: boolean;
  }>(),
  {
    customerId: "",
    isCustomerDisabled: false,
  }
);
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

.atlas-get-started-widget {
  display: flex;
  align-items: center;
  gap: 20px;
}

.atlas-get-started-widget__left {
  flex: 0 0 55%;
  min-width: 0;
}

.atlas-get-started-widget__headline {
  color: #2a2a2a;
}

.atlas-get-started-widget__headline-line {
  display: block;
}

.atlas-get-started-widget__headline-line--nowrap {
  white-space: nowrap;
}

.atlas-get-started-widget__right {
  flex: 0 0 45%;
  min-width: 0;
  max-width: 450px;
}

.atlas-get-started-widget__features {
  list-style: none;
  margin: 16px 0 24px;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.atlas-get-started-widget__feature {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1 0;
  min-width: 140px;
}

.atlas-get-started-widget__feature-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #e6efee;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.atlas-get-started-widget__feature-text {
  font-size: 13px;
  line-height: 1.35;
  color: #2a2a2a;
}

@media (max-width: $mobile-max-width) {
  .atlas-get-started-widget {
    flex-direction: column;
    align-items: stretch;
  }

  .atlas-get-started-widget__left {
    flex: 1 1 auto;
    width: 100%;
  }

  .atlas-get-started-widget__right {
    flex: 1 1 auto;
    width: 100%;
    max-width: none;
  }

  .atlas-get-started-widget__features {
    flex-direction: column;
  }

  .atlas-get-started-widget__feature {
    flex: 1 1 100%;
  }
}
</style>
